export default __webpack_public_path__ + "static/media/tax-rate-options-tiers.8e005d73.svg";